export const OUTLET = "/outlet";
export const USER = "/users";
export const HOMEPAGE = "/homepage";
export const PRODUCT = "/product";
export const CUSTOMER = "/customer";
export const CHECKOUT = "/checkout";
export const APPEND_CART = "/appendCart";
export const CART = "/cart";
export const GET_CART = "/getcart";
export const UPDATE_CART = "/updateCart";
export const USER_LOGIN = "/login";
export const USER_FORGOT_PASSWORD = "/forgot-pin";
export const USER_VERIFY_PASSWORD = "/verify-otp";
export const USER_RESEND_OTP = "/resend-otp";
export const USER_CREATE_PASSWORD = "/set-pin";
export const USER_CAPTCHA = "/captcha";
export const USER_SIGNUP = "/app-signup";
export const TICKET = "/ticket";
export const DETAILS = "/details";
export const CLEARCART = "/clearCart";
export const GUEST_SIGNUP = "/guest-signup";
export const GUEST_UPDATE = "/guest-update";
export const GUEST_CART_UPDATE = "/guestCartUpdate";
export const AQUA_CUSTOMER = "/aqua_customer";
export const GET_AQUA = "/getaqua";
export const PAYMENT = "/payment";
export const VERIFY = "/verify";
export const BOOKING_LIST = "/bookingList";
export const CANCEL_TICKET = "/cancelTicket";
export const SPIN = "/spin";
export const SIGN_UP = "/signup";
export const PROMOTION = "/promotion";
export const SPIN_WHEEL = "/spinWheel";
export const VERIFY_EMAIL = "/verifyEmail";
export const REDEEM = "/redeem";
export const REFRESHTOKEN = "/users/refreshToken";
export const ANALYTICS = "/analytics";
export const SETTINGS = "/settings";
